<template>
  <Layout>
    <PageHeader :title="'Şube & Depo Yönetimi'"
                :items="breadcrumbArray"></PageHeader>
    <v-app>
      <div class="row">
        <div class="col-lg-12 pb-5 mb-5">
          <v-tabs icons-and-text mobile-breakpoint="lg" grow>
            <v-tab>
              Şube Yönetimi
              <v-icon> mdi-source-branch </v-icon>
            </v-tab>
            <v-tab>
              Depo Yönetimi
              <v-icon> mdi-warehouse </v-icon>
            </v-tab>

            <v-tab-item>
              <BranchManagement></BranchManagement>
            </v-tab-item>
            <v-tab-item>
              <WarehouseManagement></WarehouseManagement>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </v-app>
  </Layout>
</template>
<script>
import Layout from "@/pages/layout/main.vue";
import PageHeader from "@/components/page-header";
import BranchManagement from "@/components/management/branch-management/Results.vue";
import WarehouseManagement from "@/components/management/warehouse-management/Results.vue";
export default {
  page: {
    title: "Şube & Depo Yönetimi",
    meta: [{name: "branchWarehouseManagement", content: "Şube & Depo Yönetimi"}],
  },
  name: "BranchWarehouseManagement",
  components: {
    Layout,
    PageHeader,
    BranchManagement,
    WarehouseManagement
  },
  data() {
    return {
      breadcrumbArray: [
        {
          text: "Yönetim",
          active: false,
        },
        {
          text: "Şube & Depo Yönetimi",
          active: true,
        },
      ],
    }
  }
}
</script>


<style scoped>

</style>